import { render, staticRenderFns } from "./custApproval.vue?vue&type=template&id=011ee2fc&scoped=true&"
import script from "./custApproval.vue?vue&type=script&lang=js&"
export * from "./custApproval.vue?vue&type=script&lang=js&"
import style0 from "./custApproval.vue?vue&type=style&index=0&id=011ee2fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ee2fc",
  null
  
)

export default component.exports